import { render, staticRenderFns } from "./AddressAmountCard.vue?vue&type=template&id=7daa8494&scoped=true"
import script from "./AddressAmountCard.vue?vue&type=script&lang=js"
export * from "./AddressAmountCard.vue?vue&type=script&lang=js"
import style0 from "./AddressAmountCard.vue?vue&type=style&index=0&id=7daa8494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daa8494",
  null
  
)

export default component.exports